module.exports = __webpack_public_path__ + "static/img/dialog2.f9cf08f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/web/dialog2.png
// module id = /z3w
// module chunks = 0